// Translated
// Migrated
<template>
  <b-modal
    ref="scrollTarget"
    v-model="showRooms"
    modal-class="dark-modal"
    centered
    :hide-footer="isLoading"
    :hide-header="isLoading"
    :no-close-on-backdrop="isLoading"
    :no-close-on-esc="isLoading"
    size="md"
    @hidden="close"
  >
    <template #modal-header>
      <slot name="title" />
      <div
        v-rtg-tooltip="$t('close')"
        class="btn-link modal-close-button"
        @click="close"
        @touchstart="close"
      >
        <fa icon="times" />
      </div>
    </template>
    <template #modal-footer>
      <a
        class="text-white link-underline"
        :data-i18n="footerText"
        @click="close"
        @touchstart="close"
      >{{ $t(footerText) }}</a>
    </template>
    <div
      v-if="loading && !loadingBooking"
      class="w-12/12 book-trip __booking-is-loading !mt-0 !mb-0"
    >
      <div class="form-container-blue !mb-4 mt-0 !p-0 booking__hotel-item">
        <HotelRoomSkeleton
          v-for="i in 2"
          :key="`loading-skeleton-${i}`"
        />
      </div>
    </div>
    <LazyAlert
      v-else-if="errorBooking"
      class="mx-1 my-12 __booking-had-errorBooking"
      type="error"
      data-i18n="charterErrorBooking"
    >
      {{ $t('charterErrorBooking') }}
    </LazyAlert>
    <LazyAlert
      v-else-if="error"
      class="mx-1 my-12 __booking-had-error"
      type="error"
    >
      <template #default>
        <span v-if="errorMessage">
          {{ errorMessage }}
        </span>
        <span
          v-else
          data-i18n="charterHotelError"
        >{{ $t('charterHotelError') }}</span>
      </template>
      <template #icon>
        <fa
          class="svg-inline--fa fa-w-16 fa-5x"
          :icon="faUmbrellaBeach"
        />
      </template>
    </LazyAlert>
    <Loading
      v-else-if="loadingBooking"
      :width="200"
    >
      <div
        class="mb-4"
        data-i18n="charterLoadingBooking"
      >
        {{ $t('charterLoadingBooking') }}
      </div>
    </Loading>
    <div
      v-else
      class="w-12/12 book-trip !mt-0"
    >
      <FormContainer
        v-for="(roomGroup, roomGroupIndex) in roomGroups"
        :key="roomGroupIndex"
        container-class="!mb-0 !p-0 !border-none booking__hotel-item"
        title-class="!mb-0 !px-10"
        content-class="py-0 pl-3 pr-3 md:pr-2"
      >
        <template #title>
          <span data-i18n="chooseRoomType">
            {{ $t('chooseRoomType', { room: roomGroupIndex + 1 }) }}
          </span>
          <span
            v-if="roomAdults(roomGroup) > 0"
            class="small ml-4"
            data-i18n="chooseRoomTypeAdults"
          >{{ $t('chooseRoomTypeAdults', roomAdults(roomGroup)) }}</span>
          <span
            v-if="roomKids(roomGroup) > 0"
            class="small ml-4"
            data-i18n="chooseRoomTypeChildren"
          >{{ $t('chooseRoomTypeChildren', roomKids(roomGroup)) }}</span>
        </template>
        <template #content>
          <HotelModalRoomRow
            v-for="(room, roomIndex) in sortRoomGroup(roomGroup)"
            :key="`room_${roomIndex}_${roomGroupIndex}_${hgKey}`"
            :scroll-target="scrollTarget"
            :room="room"
            :room-index="roomIndex"
            :room-group-index="roomGroupIndex"
            :selection="selectedRooms[roomGroupIndex]"
            :is-inactive="roomOptionIsUnavailable(roomGroupIndex, roomIndex)"
            :room-group-length="roomGroup.length"
            :has-multiple-room-options="hasMultipleRoomOptions(roomGroupIndex)"
            @select-room="selectRoom"
            @open-gallery="(images) => $emit('open-gallery', images)"
          />
        </template>
      </FormContainer>
      <div
        v-if="!roomGroups.length"
        class="px-12 py-4"
      >
        <LazyAlert
          type="warning"
          data-i18n="charterHotelNoMoreRooms"
        >
          {{ $t('charterHotelNoMoreRooms') }}
        </LazyAlert>
      </div>
      <div
        v-else
        class="form-container-blue !mb-0"
      >
        <div class="form-group flex items-center justify-end">
          <slot
            name="pricing"
            :total-room-prices="totalRoomPrices"
          />
          <button
            class="btn btn-blue btn-lg"
            :disabled="allRoomsSelected"
            data-button="hotel-go-next"
            data-i18n="formNextButton"
            @click="$emit('go-next')"
          >
            {{ $t('formNextButton') }}
          </button>
        </div>
        <div
          v-if="priceInfo"
          class="alert alert-info"
        >
          <table class="table mb-0 bg-white w-full">
            <tr
              v-for="(priceLine, index) in priceInfo"
              :key="index"
            >
              <td>
                <span class="text-wrap">
                  {{ priceLine.description || priceLine.type }}
                </span>
              </td>
              <td :title="$currency(priceLine.amountSek, {symbol: 'SEK'} ).format()">
                {{ $currency(priceLine.baseAmount, {symbol: priceLine.baseCurrency}).format() }}
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { faGameConsoleHandheldCrank, faUmbrellaBeach } from '@fortawesome/pro-duotone-svg-icons'
import { mapActions, mapState } from 'pinia'

import events from '@layers/web/constants/events.js'

export default defineNuxtComponent({
  setup (props) {
    const { trackViewContent } = useTracking()
    let roomStore

    if (props.bookType === 'charterpackages') {
      roomStore = useCharterPackagesStore()
    } else if (props.bookType === 'charter') {
      roomStore = useCharterStore()
    } else if (props.bookType === 'book'){
      roomStore = useBookStore()
    }
    return {
      trackViewContent,
      roomStore,
    }
  },

  props: {
    loadingBooking: {
      type: Boolean,
      default: false,
    },

    errorBooking: {
      type: Boolean,
      default: false,
    },

    bookType: {
      type: String,
      default: 'book',
    },

    selectedRooms: {
      type: Array,
      required: true,
    },

    dealfinder: {
      type: Boolean,
      default: false,
    },
  },

  emits: [
    'go-next',
    'unselect-rooms',
    'select-room',
    'close-hotel',
    'close-rooms',
    'open-gallery',
  ],

  data () {
    return {
      faUmbrellaBeach,
      faGameConsoleHandheldCrank,

      hgKey: 0,

      error: false,
      errorMessage: '',
      loading: true,
      showRooms: false,

      hotel: { meta: {} },
      hotelId: null,

      priceInfo: null,
      basePrice: 0,

      scrollTarget: null,
    }
  },

  computed: {
    ...mapState(useCharterPackagesStore, {
      getBoard: 'getBoard',
    }),

    ...mapState(useLocaleStore, {
      locale: 'locale',
    }),

    ...mapState(useBookStore, {
      selectedRoomGroup: 'selectedRoomGroup',
    }),

    ...mapState(useCharterStore, {
      previousHotelId: 'modalHotelId',
    }),

    ...mapState(useCharterPackagesStore, {
      boards: state => state.filters.boards,
    }),

    roomGroups () {
      const rooms = []
      const roomTypes = (this.roomtypes || [])

      roomTypes.forEach((room, index) => {
        const images = room.pictures.map((i) => {
          if (i.structured) {
            const imageInfo = Object.values(i.structured.images.images)?.[0]
            let imagePath = parseURI(imageInfo.href, true).pathname

            if (i.image_type === 'expedia') {
              imagePath = imagePath?.replace(/_[a-z].jpg/, '')
            }

            return {
              type: i.image_type,
              image: imagePath,
            }
          }

          return {
            type: i.image_type,
            image: i.image,
          }
        })

        const roomSeq = parseInt(room.seq) - 1
        const roomGroup = room.groupid

        if (!rooms[roomSeq]) {
          rooms[roomSeq] = {}
        }
        if (!rooms[roomSeq][roomGroup]) {
          rooms[roomSeq][roomGroup] = []
        }

        // !TODO convert this to array stucture
        rooms[roomSeq][roomGroup].push({
          ...room,
          images,
          id: room.roomid,
          originalIndex: index,
        })
      })

      this.addScrollTarget()

      return rooms.filter(r => !!r)
    },

    roomtypes () {
      return this?.roomStore.modalRoomTypes || []
    },

    allRoomsSelected () {
      return Object.values(this.selectedRooms).filter(r => !!r).length !== this.roomGroups.length
    },

    totalRoomPrices () {
      let price = this.basePrice

      if (!this.showRooms) {
        return price
      }

      this.selectedRooms.forEach((r) => {
        const room = this.roomtypes.find(rt => rt.roomid === r)

        if (room) {
          price += room.price
        }
      })

      return price
    },

    bookTypeState () {
      return this.roomStore.rooms
    },

    isLoading () {
      return this.loadingBooking && !this.errorBooking
    },

    footerText () {
      return this.dealfinder ? 'hotelBackToCalendar' : 'hotelBackToList'
    },
  },

  watch: {
    '$route.query.showRooms' () {
      if (!this.$route.query.showRooms) {
        this.close()
      }
    },

    roomGroups () {
      this.selectFirstRoomIfOnlyOption()
    },
  },

  mounted () {
    this.selectFirstRoomIfOnlyOption()
    this.$event.$on(events.showHotelModalRooms, this.showModal)
    this.$event.$on(events.closeHotelModalRooms, this.hidingModal)
  },

  beforeUnmount () {
    this.$event.$off(events.showHotelModalRooms, this.showModal)
    this.$event.$off(events.closeHotelModalRooms, this.hidingModal)
  },

  methods: {
    ...mapActions(useCharterStore, {
      charterRoomData: 'roomData',
    }),
    ...mapActions(useBookStore, {
      bookRoomData: 'roomData',
      setRoomGroup: 'SET_ROOMGROUP',
    }),

    ...mapActions(useCharterPackagesStore, {
      charterpackagesRoomData: 'roomData',
      getState: 'getState',
      getFlight: 'getFlight',
    }),

    sortRoomGroup (roomGroup) {
      return Object.values(roomGroup).sort((a, b) => a[0]?.originalIndex > b[0]?.originalIndex ? 1 : -1)
    },

    hasMultipleRoomOptions (roomGroupIndex) {
      if (this.roomGroups?.length && roomGroupIndex !== undefined) {
        return (
          Object.values(this.roomGroups[roomGroupIndex]).length > 1 ||
          Object.values(this.roomGroups[roomGroupIndex]).some(roomOptions => roomOptions?.length > 1)
        )
      }

      return false
    },

    selectFirstRoomIfOnlyOption () {
      if (this.roomGroups?.length) {
        this.roomGroups.forEach((roomGroup, roomGroupIndex) => {
          if (this.hasMultipleRoomOptions(roomGroupIndex)) {
            return
          }

          const selectRoom = Object.values(roomGroup || {})?.[0]?.[0]

          if (selectRoom) {
            this.selectRoom(roomGroupIndex, selectRoom.id, 0)
          }
        })
      }
    },

    showModal (hotel) {
      this.hotelId = hotel.id || hotel.hotel_code
      this.hotel = hotel

      const openingSameHotelAgain = this.hotelId !== this.previousHotelId || `${this.hotelId}` !== `${this.previousHotelId}`

      if (openingSameHotelAgain || this.errorBooking) {
        this.$emit('unselect-rooms')
        this.setRoomGroup({})
      }

      this.showRooms = true
      this.loadRooms()

      this.trackViewContent({
        name: this.hotel.hotel,
        value: this.hotel.pricepp ?? this.hotel.price,
        id: this.hotel.hotel_code ?? this.hotel.id,
      })
    },

    hidingModal () {
      this.showRooms = false
    },

    firstRoomGroup (roomGroups) {
      return roomGroups[Object.keys(roomGroups)[0]]
    },

    selectRoom (roomGroupIndex, roomId, roomIndex) {
      this.$emit('select-room', {
        index: roomGroupIndex,
        room: roomId,
      })

      const selectedRoomGroup = { ...this.selectedRoomGroup }
      selectedRoomGroup[roomGroupIndex] = roomIndex
      this.setRoomGroup(selectedRoomGroup)
    },

    async loadRooms () {
      this.errorMessage = ''
      if (this.roomtypes.length && this.previousHotelId === this.hotelId) {
        this.error = false
        this.loading = false
        this.showRooms = true
        return
      }

      this.error = false
      this.loading = true
      this.showRooms = true

      const request = {
        hotelid: (this.hotel.hotel_code || this.hotel.id),
        supplier: this.hotel.supplier,
        giataId: this.hotel.giataId || this.hotel.giata_id,
      }

      try {
        if (this.bookType === 'charterpackages') {
          if (this.boards && !this.dealfinder) {
            request.board = this.getBoard
          }
          const stateRequest = {
            origin: this.hotel.origin,
            rooms: this.bookTypeState,
            tripDate: this.hotel.date,
            returnDate: this.hotel.return_date,
            supplier: this.hotel.supplier,
            hotelId: this.hotel.hotel_code,
            giataId: this.hotel.giataId || this.hotel.giata_id,
            destination: this.hotel.destination,
            price: this.hotel.total_price || this.hotel.price,
          }
          if (this.hotel.origin) {
            await Promise.all([
              this.getState(stateRequest),
              this.getFlight(stateRequest),
            ])
          } else {
            return
          }
        }
        // book type preventing mapActions
        const roomData = await this[`${this.bookType}RoomData`](request)

        if (roomData?.minimum_package_price) {
          this.basePrice = roomData?.minimum_package_price
        }

        if (roomData?.priceInfo) {
          this.priceInfo = roomData?.priceInfo
        }

        if (!this.showRooms) {
          return
        }

        this.loading = false
      } catch (e) {
        if (e.data?.error) {
          if (e.data.message === 'state_expired') {
            this.$emit('close-hotel')
            return
          }
          if (e.data?.roomCount && e.data?.roomCountRequired && e.data?.roomCount < e.data?.roomCountRequired) {
            this.errorMessage = this.$t('dealfinder.error.notEnoughRooms', [e.data.roomCount])
          }
          if (e.data?.localeKey === 'error.rooms.zero-rooms'){
            this.errorMessage = this.$t('charterHotelNoMoreRooms')
          }
          this.$sentrySetContext('details', e.data)
          this.$sentryCaptureException(`${this.bookType}/roomData error`, {
            level: 'error',
            tags: {
              type: 'UX',
            },
          })
        }

        this.loading = false
        this.error = true
      }
      // to properly load the refs and calculate the height
      this.$nextTick(() => {
        this.hgKey++
      })
    },

    roomAdults (value) {
      return parseInt(this.firstRoomGroup(value)[0].adults)
    },

    roomKids (value) {
      return parseInt(this.firstRoomGroup(value)[0].children)
    },

    close () {
      this.$emit('close-rooms')
    },

    roomOptionIsUnavailable (roomGroupIndex, roomIndex) {
      return typeof this.selectedRoomGroup[roomGroupIndex] === 'number' && this.selectedRoomGroup[roomGroupIndex] !== roomIndex
    },

    addScrollTarget () {
      this.scrollTarget = this.$refs.scrollTarget?.$el.children?.[0]
    },
  },
})
</script>
